<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
<!--    <van-sticky>-->
<!--      <div class="step-box">-->
<!--        <van-steps :active="active">-->
<!--          <van-step>第一步</van-step>-->
<!--          <van-step>第二步</van-step>-->
<!--          <van-step>第三步</van-step>-->
<!--        </van-steps>-->
<!--      </div>-->
<!--    </van-sticky>-->
    <div v-if="loading">
      <van-form
          @submit="onSubmit"
          @failed="onFailed"
          v-if="active == 0"
      >
        <van-cell-group>
          <van-field
              v-model="formData.danwei"
              :rules="[{ required: true, message: '单位名称不能为空' }]"
              label="单位名称"
              input-align="right"
              error-message-align="right"
              left-icon="question-o"
              @click-left-icon="onQuestion('danwei')"
              clearable
              placeholder="请输入单位名称"
          />
          <van-field name="radio" label="类型"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.kaojitype" direction="horizontal">
                <van-radio checked-color="#ffb01b" name="考级中心">考级中心</van-radio>
                <van-radio checked-color="#ffb01b" name="考级点">考级点</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" v-if="formData.kaojitype=='考级中心'" label="考级中心类型"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.kaoji_jiameng_type">
                <!-- <van-radio checked-color="#ffb01b" name="4">指定考级中心（投入成本12万元）</van-radio> -->
                <van-radio checked-color="#ffb01b" name="5">样板考级中心（投入成本13.5万元）</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" v-else label="考级点类型"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.kaoji_jiameng_type">
                <van-radio checked-color="#ffb01b" name="2">考级点（预备）（投入成本0元）</van-radio>
                <van-radio checked-color="#ffb01b" name="3">样板考级点（投入成本9800元）</van-radio>
                <van-radio checked-color="#ffb01b" name="7">街舞啦啦操考点</van-radio>
              </van-radio-group>
            </template>
          </van-field>


          <van-cell title="协议下载/上传" v-show="formData.kaoji_jiameng_type>2"  > 
          </van-cell>

          <div class="row"  v-show="formData.kaoji_jiameng_type>2" >
            <PicUploader :fileList="formData.xieyipic" :limit="20"
                         :name="'xieyipic'"></PicUploader>
          </div>
          <div  v-show="formData.kaoji_jiameng_type>2"  class="operate-desc-left" @click="xieyiDownload()" style="color:#1989fa">请先点击这里下载《协议模版》打印盖章后拍照上传协议照片</div>
          <van-cell title="单位执照" :value="formData.zhizhaopic.length+'/1'"> 
          </van-cell>

          <div class="row">
            <PicUploader :fileList="formData.zhizhaopic" :limit="1"
                         :name="'zhizhaopic'"></PicUploader>
          </div>
          <div class="operate-desc-left">上传营业执照 或 法人证书 或 组织结构代码证</div>

                 <van-field
                     v-model="formData.chandimianji"
                     label="场地面积"
                     :rules="[{ required: true, message: '场地面积不能为空' }]"
                     error-message-align="right"
                     type="number"
                     input-align="right"
                     clearable
                     placeholder="请输入场地面积（平米）"
                 />


                 <van-field
                     v-model="formData.yundongyuanrenshu"
                     :rules="[{ required: true, message: '人数不能为空' }]"
                     error-message-align="right"
                     label="人数"
                     type="number"
                     input-align="right"
                     clearable
                     placeholder="请输入人数"
                 />

          <van-field
              readonly
              clickable
              name="area"
              :value="formData.province+'/'+formData.city+'/'+formData.county"
              input-align="right"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :value="formData.area"
                @confirm="onAreaConfirm"
                @cancel="showArea = false"
            />
          </van-popup>


          <van-field
              v-model="formData.address"
              :rules="[{ required: true, message: '请输入详细地址' }]"
              error-message-align="right"
              label="详细地址"
              input-align="right"
              clearable
              placeholder="请输入详细地址"
          />


                 <van-cell title="场地照片" :value="formData.changdipic.length+'/5'">
                 </van-cell>

                 <div class="row">
                   <PicUploader :fileList="formData.changdipic" :limit="5"
                                :name="'changdipic'"></PicUploader>
                 </div>
                 <div class="operate-desc-left">上传5张场地照片</div>


          <!--        <van-field-->
          <!--            v-model="formData.user_code"-->
          <!--            error-message-align="right"-->
          <!--            label="个人编码"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入个人编码"-->
          <!--        />-->

        </van-cell-group>


        <van-divider>负责人信息</van-divider>

        <van-cell-group>

          <van-field
              v-model="formData.nickname"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="姓名"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />


                 <van-field
                     v-model="formData.certificatenumber"
                     :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                     error-message-align="right"
                     label="身份证号"
                     input-align="right"
                     clearable
                     placeholder="请输入身份证号"
                 />


          <!--        <van-field-->
          <!--            v-model="formData.email"-->
          <!--            :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"-->
          <!--            error-message-align="right"-->
          <!--            label="邮箱"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入邮箱"-->
          <!--        />-->


          <van-field
              v-model="formData.phone"
              :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
              error-message-align="right"
              label="手机"
              input-align="right"
              clearable
              placeholder="请输入手机"
          /> 
          <!--        <van-field-->
          <!--            v-if="false"-->
          <!--            v-model="formData.qq"-->
          <!--            label="QQ"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入QQ"-->
          <!--        />-->

          <!--        <van-field-->
          <!--            v-model="formData.weixin"-->
          <!--            label="微信号"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入微信号"-->
          <!--        />-->

        </van-cell-group>

        <van-divider>日常联系人信息
        </van-divider>

        <van-cell-group>

          <van-field
              v-model="formData.contactsname"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="姓名"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />


                 <van-field
                     v-model="formData.contactscertificatenumber"
                     :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                     error-message-align="right"
                     label="身份证号"
                     input-align="right"
                     clearable
                     placeholder="请输入身份证号"
                 />


                 <van-field
                     v-model="formData.contactsemail"
                     :rules="[{ validator: validator.email,message:'请输入正确的邮箱'}]"
                     error-message-align="right"
                     label="邮箱"
                     input-align="right"
                     clearable
                     placeholder="请输入邮箱"
                 />


          <van-field
              v-model="formData.contactsphone"
              :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
              error-message-align="right"
              label="手机"
              input-align="right"
              clearable
              placeholder="请输入手机"
          />

                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>
          <!--        <van-field-->
          <!--            v-model="formData.contactsqq"-->
          <!--            label="QQ"-->
          <!--            v-if="false"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入QQ"-->
          <!--        />-->

          <!--        <van-field-->
          <!--            v-model="formData.contactsweixin"-->
          <!--            label="微信号"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入微信号"-->
          <!--        />-->

        </van-cell-group>

        <div class="savebtn">
          <!--        <van-button-->
          <!--            style="width: 3rem"-->
          <!--            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..."-->
          <!--            native-type="submit" @click="save">暂存信息-->
          <!--        </van-button>-->

          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            提交申请
          </van-button>
        </div>
      </van-form>

<!--      <div class="step-two" v-if="active == 1">-->
<!--        <van-cell-group>-->
<!--          <ul class="step-two-box">-->
<!--            <li>提交申报信息成功！</li>-->
<!--            <li>等待审核工作人员与您取得联系。。。</li>-->
<!--            <li>如需加快进度，请点击“催一催”按钮</li>-->
<!--            <li>在获得工作人员授意后，点击 “刷新”按钮，方可进行下一步操作</li>-->
<!--          </ul>-->

<!--        </van-cell-group>-->
<!--        <div class="savebtn">-->
<!--          <van-button-->
<!--              style="width: 3rem"-->
<!--              size="normal" round-->
<!--              @click="$toast.success('催促成功')">催一催-->
<!--          </van-button>-->

<!--          <van-button-->
<!--              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--              style="width: 3rem"-->
<!--              size="normal" round @click="fetch()">刷新-->
<!--          </van-button>-->
<!--        </div>-->
<!--      </div>-->
      <div class="step-three" v-if="active == 1 || active == 2">
        <van-form
            @submit="onSubmitThree"
            @failed="onFailed"
        >
          <van-cell-group>
            <div class="step-three-title">确认验收信息</div>
            <div class="step-three-content">
              <div>请确认您的创建清单：</div>
              <div class="step-three-danwei">{{ formData.danwei }} （{{formData.kaojitype}}）</div>
              <div class="step-three-danwei" v-if="formData.kaoji_jiameng_type == 2">0元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 3">9800元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 4">12万元</div>
              <div class="step-three-danwei" v-else-if="formData.kaoji_jiameng_type == 5">13.5万元</div>
            </div>
            <van-cell title="请下载文化布置，发至广告公司制作">
            </van-cell>
            <div class="dialog-step-li" v-if="formData.kaojitype == '考级点'">
              <div class="dialog-step-li-text"
                   @click="download({name:'新七彩星级文化包', url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/newqicaixingjiwenhuabao.rar'})">
                考级点文化包（兼容版）请下载制作
              </div>
            </div>

            <div class="dialog-step-li" v-if="formData.kaojitype == '考级中心'">
              <div class="dialog-step-li-text"
                   @click="download({name: '新七彩星级文化包', url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/newqicaixingjiwenhuabao.rar'})">
                考级中心文化包（兼容版）请下载制作
              </div>
            </div>

            <van-cell title="请上传现场文化布置图" v-show="showUpload">
            </van-cell>
            <div class="row"  v-show="showUpload">
              <PicUploader :fileList="formData.kaoji_yanshoufile" :limit="5"
                           :name="'kaoji_yanshoufile'"></PicUploader>

<!--              <FileUploader uploadText="图片证明" :fileList="[]" :limit="1" :name="'yanshou_pic'"></FileUploader>-->
            </div>
          </van-cell-group>
          <div class="savebtn">
            <van-button
            v-show="false"
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                native-type="submit"
                size="normal" round @click="onPay">
              我要付款
            </van-button>
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                @click="submit">
              完成申报
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <van-dialog v-model="showPay" title="收款账户" :show-confirm-button="false" :close-on-click-overlay="true">
      <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px;">
        <img style="width: 100%;" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg"/>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round @click="onPayDownload">下载二维码
        </van-button>
      </div>
    </van-dialog>

    <van-dialog v-model="contactShow" title="联系人信息" :show-cancel-button="false" :close-on-click-overlay="true" @close="onContactClose">
      <div style="width: 80%;margin: 0px auto 20px; ">
        <div>姓名：{{contactRow.name}}</div>
        <div>电话：<a :href="'tel:'+contactRow.phone" style="color: #409eff">{{contactRow.phone}}</a></div>
      </div>
    </van-dialog>
  </div>
</template>
<style scoped>
.step-box {
  margin: 0 .2rem .2rem;
}

.dialog-step-li {
  margin: .2rem .3rem 0;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.step-three-title {
  font-size: 24px;
  padding: .3rem 0;
  text-align: center;
}

.step-three-content {
  margin: 0 .3rem;
  font-size: 16px;
}

.step-three-danwei {
  margin: .1rem 0 .3rem;
}

/*.van-form .row {*/
/*  padding: 10px 15px;*/
/*  display: flex;*/
/*}*/
.step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Step,
  Steps,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  Sticky
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Steps).use(Step).use(Sticky);
export default {
  name: 'StationApplyMine',
  components: {
    PicUploader, FileUploader
  },
  data: function () {
    return {
      validator,
      loading: false,
      showPay: false,
      saveLoading: false,
      showArea: false,
      contactShow: false,
      active: 0,
      areaList: {},
      areaValue: '',
      submitType: '',
      showUpload:false,
      submitThreeType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
        kaojitype: '考级中心',
        kaoji_jiameng_type: '',
        kaoji_yanshoufile: [],
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
        xieyipic: [],
      },
      contactRow: {
        name: 'xx',
        phone: '111'
      },
      xieyiUrls:[
        'https://ccago.oss-cn-hangzhou.aliyuncs.com/template/%E8%80%83%E7%BA%A7%E4%B8%AD%E5%BF%83%EF%BC%88%E7%82%B9%EF%BC%89%E5%8D%8F%E8%AE%AE/12%E4%B8%87%E5%85%83%E8%80%83%E7%BA%A7%E4%B8%AD%E5%BF%83%E5%8D%8F%E8%AE%AE.doc',
        'https://ccago.oss-cn-hangzhou.aliyuncs.com/template/%E8%80%83%E7%BA%A7%E4%B8%AD%E5%BF%83%EF%BC%88%E7%82%B9%EF%BC%89%E5%8D%8F%E8%AE%AE/13.5%E4%B8%87%E5%85%83%E8%80%83%E7%BA%A7%E4%B8%AD%E5%BF%83%E5%8D%8F%E8%AE%AE.doc',
        'https://ccago.oss-cn-hangzhou.aliyuncs.com/template/%E8%80%83%E7%BA%A7%E4%B8%AD%E5%BF%83%EF%BC%88%E7%82%B9%EF%BC%89%E5%8D%8F%E8%AE%AE/9800%E8%80%83%E7%BA%A7%E7%82%B9%E5%8D%8F%E8%AE%AE.doc'
      ],
      xieyiUrl:'',
      clockSecond:0,
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    that.showUpload = this.$route.query.showupload>0 ? true:false
    document.title = "创建七彩星级"

//            if(that.formData.id){
    this.fetch();
//            }
  },
  watch: {
    'formData.kaoji_jiameng_type':function(val){
      console.log(val);
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      if (that.formData.kaojitype == '考级中心') {
        if (that.formData.kaoji_jiameng_type != 4 && that.formData.kaoji_jiameng_type != 5) {
          Toast('请选择考级中心类型');
          return;
        }
      } else if (that.formData.kaojitype == '考级点') {
        if(that.formData.kaoji_jiameng_type != 2 && that.formData.kaoji_jiameng_type != 3&& that.formData.kaoji_jiameng_type != 7 ){
          Toast('请选择考级点类型');
          return;
        }
      }

      for (let field in that.formData) {

        // if (that.formData.changdipic.length != 5) {
        //   Toast('请上传5张场地照片');
        //   return
        // }
        if (that.formData.zhizhaopic.length == 0) {
          Toast('请上传单位执照');
          return
        }
        if (that.formData.kaoji_jiameng_type>2 && that.formData.xieyipic.length == 0) {
          Toast('请上传协议照片');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }

      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {
        that.$api.post('/api/examecenter/applySimple', that.formData, (res) => {
          that.saveLoading = false;

          // 判断申请的是否是
          if(res.data.city.indexOf('佛山') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else if(res.data.city.indexOf('郑州') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else if(res.data.province.indexOf('湖南') >= 0) {
            // 邓晓茜 15919084409
            that.contactRow.name = '邓晓茜'
            that.contactRow.phone = '15919084409'
            that.contactShow = true
          } else {
            // 跳转改为步骤条进行
            that.active = 1
          }

          return
          rbLink({
            name: "QcxjStationResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onSubmitThree(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;

      if(that.submitThreeType == 'show' || !that.submitThreeType) return
      console.log(that.formData)
      that.formValidate = true;

      if( this.showUpload && this.formData.kaoji_yanshoufile.length <3) {
        Toast('请至少上传3张文化布置图');
        return
      }
      that.saveLoading = true;

      that.$api.post('/api/examecenter/fileEdit', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')
        rbLink({
          name: "ClubIndex",
          query: {
            id: res.data.id
          }
        }, 'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },

    // 我要付款
    onPay() {
      this.submitThreeType = 'show'
      this.showPay = true
    },

    onPayDownload() {
      this.download({
        name: '啦啦操收款二维码',
        url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg'
      })
    },

    download(file){
      appEvent({
        name: 'downloadFile',
        query: {
          name:file.name,
          url:file.url,
        }
      });
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit';
    },

    onContactClose() {
      this.active = 1
    },

    fetch() {
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id: that.formData.id
      }, (res) => {
        that.loading = true
        that.formData = res.data;
        if (res.data.kaojiregist_status == 1) {
          that.active = 1;
          return;
          rbLink({
            name: "QcxjStationResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        } else if (res.data.kaojiregist_status == 2) {
          that.active = 2;
        }
      }, (res) => {
        that.loading = true
//                    Toast.fail(res.msg);
      })
    },
    xieyiDownload(){
      let xieyiUrl = '';
      // console.log(this.formData.kaoji_jiameng_type)
      switch(this.formData.kaoji_jiameng_type){
        case '3':
          //9800
          xieyiUrl = this.xieyiUrls[2];
          break;
          case '4': 
          xieyiUrl = this.xieyiUrls[0];
          break;
          case '5': 
          xieyiUrl = this.xieyiUrls[1];
          break;
      }
      if(!xieyiUrl){
        return ;
      } 
      console.log(xieyiUrl);
        let that = this; 
        appEvent({
            name: 'downloadFile',
            query: {
              name: '协议下载',
              url: xieyiUrl
            }
        });
    },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.contactsphone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.contactsphone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }

  }
}
</script>



// WEBPACK FOOTER //
// StationApplyMine.vue?5116a98c